/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/quickCreate/quickContentModal/currentContent/currentContentView",
], function (Marionette, Backbone, Messenger, CurrentContentView) {
  var CurrentContentController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "currentContent";
      this.region = options.region;
    },
    show: function (content) {
      //if there is no content, create a basic model
      if (content == null) {
        content = new Backbone.Model({ mappingId: 0 });
      }
      this.view = new CurrentContentView.currentContentView({ model: content });

      this.view.on("remove:content", function () {
        //trigger a vent to let the parent module know that the remove button was clicked
        Messenger.vent.trigger("remove:selected:content");
      });
      this.showRegion(this.view);
    },
  });

  return CurrentContentController;
});
